import api from './data.services'
import { authService } from './'

const favoritesSrv = 'favourites'

const getFavoritesByUserCurrent = async () => {
  try {
    const resp: any = await api.get(favoritesSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.Favourites ? resp.data.Favourites : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener favoritos!'
    }
  }
}

const postFavoritesByUserCurrent = async (favoritesData: any) => {
  try {
    const resp: any = await api.post(favoritesSrv, { favourites: favoritesData }, authService.getToken())

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data && resp.data.favourites ? resp.data.favourites : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error) {
    return {
      status: 'Error',
      error
    }
  }
}

export const menuService = {
  getFavoritesByUserCurrent,
  postFavoritesByUserCurrent
}